import { render, staticRenderFns } from "./FundraiserBlock.vue?vue&type=template&id=5b5be87f&lang=html&"
import script from "./FundraiserBlock.vue?vue&type=script&lang=js&"
export * from "./FundraiserBlock.vue?vue&type=script&lang=js&"
import style0 from "./FundraiserBlock.vue?vue&type=style&index=0&id=5b5be87f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports